/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

const SimpleTooltip = ({ label, className = '', backgroundColor = 'bg-dark', style = {} }) => (
  <div className={`simple-tooltip ${className} ${backgroundColor}`} style={style}>
    <i
      className="position-absolute"
      style={{
        top: '-10%',
        left: style?.arrowLeft || '52%',
        transform: 'translateY(-50%) translateX(-50%) rotate(90deg)',
      }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none">
        <path d="M0 7.88574L8 14.8857L8 0.885742L0 7.88574Z" fill="#ffffff" />
      </svg>
    </i>
    <p className="text-f6 text-grey-light text-nowrap">{label}</p>
  </div>
);

export default SimpleTooltip;

SimpleTooltip.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  style: PropTypes.object,
};
